import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAuth } from "contexts/AuthContext";
import { Floor } from "utils/floor";

type UpdateFloorImagePayload = {
  s3Url: string;
  metadata?: {
    floorplan?: {
      width: number;
      height: number;
    };
    mpp?: number;
  };
};

const useUpdateFloorImageMutation = (projectId: string) => {
  const { authApi } = useAuth();
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: async ({ floorId, payload }: { floorId: string; payload: UpdateFloorImagePayload }) => {
      if (!projectId || !floorId) return;
      const { data } = await authApi.patch<Floor>(`/floor/${floorId}/update-image`, payload);
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["floors", projectId],
      });
    },
  });
};

export default useUpdateFloorImageMutation;
